import { render, staticRenderFns } from "./PagamentoRetorno.vue?vue&type=template&id=49a92fd8&scoped=true"
import script from "./PagamentoRetorno.vue?vue&type=script&lang=js"
export * from "./PagamentoRetorno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a92fd8",
  null
  
)

export default component.exports